import React, {Component} from "react";
import { observer } from "mobx-react";
import Card from "./Card";
import {IconeCarregar, IconeDelete} from "./Icones";
import {Input, Label, Row} from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

/*
    Parametros obrigatórios
        anexos // guardaNovo // removerAnexo // descricao

    Parametros não obrigatórios
         //
*/

@observer
export class AreaInserirAnexos extends Component {
    constructor(props) {
        super(props);
    };

    componentDidMount() { };

    handleGuardaNovo = (event) => {
        this.props.guardaNovo(event);
    };
    
    render() {
        const listaArquivos = this.props.anexos;
        return (
            <Card className="card-branco area-inserir-anexos">
                <Input type="file" onChange={(event) => this.handleGuardaNovo(event)} multiple />
                { listaArquivos.length>0
                    &&  listaArquivos.map((arq, x) => (
                        <React.Fragment key={x}>
                            <div className={`item-anexo`}>
                                    <span>{`${arq ? arq.DscAnexo : arq[this.props.descricao]}`}</span>
                                    <span>
                                        { (arq.salvando)
                                            ? <IconeCarregar tamanho="lg" />
                                            :
                                            <React.Fragment>
                                                <IconeDelete tamanho="lg" className={this.props.edicao && arq.Id ? "mr-3":""} onClick={() => this.props.removerAnexo(x, arq.Id)}/>
                                                {this.props.edicao && arq.Id ? <FontAwesomeIcon icon={"paperclip"} size={"lg"} onClick={() => this.props.visualizarAnexo(arq.Id)}/> : ""}
                                            </React.Fragment>
                                        }
                                    </span>
                            </div>
                            { arq.mensagem ? <Label className="msg label-danger">{ arq.mensagem }</Label> : "" }
                        </React.Fragment>
                    ))
                }
            </Card>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/comum/components/AreaInserirAnexos.js